import {
  emitProjectAgentRegistryPoke,
  listenProjectAgentRegistryPoke,
} from '@/features/rpa/project-agent-ipc';
import { createProjectsBackgroundRegistry } from '@heidi/agents/data';

// One registry for the app, bound to the desktop IPC poke. Each name is its own
// export so the root's export lock still sees them.
const registry = createProjectsBackgroundRegistry({
  emitProjectAgentRegistryPoke,
  listenProjectAgentRegistryPoke,
});

export const registerProjectBackground = registry.registerProjectBackground;
export const unregisterProjectBackground = registry.unregisterProjectBackground;
export const subscribeProjectBackground = registry.subscribeProjectBackground;
export const getProjectBackgroundSnapshot = registry.getProjectBackgroundSnapshot;
export const __resetProjectsBackgroundRegistryForTests =
  registry.__resetProjectsBackgroundRegistryForTests;
